/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type RequestPasswordEmailInput = {
    readonly email: string;
    readonly urlRedirect?: string | null;
    readonly clientMutationId?: string | null;
};
export type requestPasswordEmailMutationVariables = {
    readonly input: RequestPasswordEmailInput;
};
export type requestPasswordEmailMutationResponse = {
    readonly requestPasswordEmail: {
        readonly message: string | null;
    } | null;
};
export type requestPasswordEmailMutation = {
    readonly response: requestPasswordEmailMutationResponse;
    readonly variables: requestPasswordEmailMutationVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "input",
            "type": "RequestPasswordEmailInput!",
            "defaultValue": null
        } as any)
    ], v1 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "requestPasswordEmail",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "RequestPasswordEmailPayload",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "message",
                    "args": null,
                    "storageKey": null
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "requestPasswordEmailMutation",
            "type": "Mutations",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "requestPasswordEmailMutation",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v1 /*: any*/)
        },
        "params": {
            "operationKind": "mutation",
            "name": "requestPasswordEmailMutation",
            "id": "ferrum/232.0.0-2019-09-10T19:14:50.345Z/requestPasswordEmailMutation",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'c47d3db474d84df4600499e03a9b2ab7';
export default node;
